export const FormSections = {
    REFERRAL_OPPORTUNITY_FOUND: 1,
    REFERRAL_REFERENCE_ENRICHED: 2,
    REFERRAL_WRITTEN: 3,
    AUCTION_MEMBER_INFO_ENRICHED: 4,
    AUCTION_REFERENCE_ENRICHED: 5,
    AUCTION_WRITTEN: 6,
    AUCTION_ENDED: 7,
};
